import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { fetchAllTypeaheadPositionInCompany, clearTypeahed } from '../../../actions';
import MultiTypeahead from './MultiTypeahead';
import renderMultiSuggestion from '../RenderMultiSuggestion';

class PositionInCompanyTypeahead extends Component {
    static propTypes = {
        fetchAllTypeaheadPositionInCompany: PropTypes.func.isRequired,
        error: PropTypes.string,
        suggestions: PropTypes.array,
        onChangeSuggestion: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        renderMultiSuggestion: PropTypes.func,
        clearTypeahed: PropTypes.func,
        animatedPlaceholder: PropTypes.bool,
        disabled: PropTypes.bool,
        isRequired: PropTypes.bool
    };

    static defaultProps = {
        suggestions: [],
        renderMultiSuggestion
    };

    state = {
        isLoading: false
    };

    onFocus = async () => {
        this.setState({ isLoading: true });

        try {
            await this.props.fetchAllTypeaheadPositionInCompany(PositionInCompanyTypeahead.name);
        } finally {
            this.setState({ isLoading: false });
        }
    };

    render() {
        const { suggestions,
            value,
            animatedPlaceholder,
            onChangeSuggestion,
            clearTypeahed,
            renderMultiSuggestion,
            error,
            disabled,
            isRequired = false,
            t } = this.props;
        const options = suggestions.length ?
            suggestions.map(position => ({ label: position.name, value: position.id })) : [];

        return (
            <MultiTypeahead
                options={options}
                isMulti
                isLoading={this.state.isLoading}
                value={value}
                titleId="positionInCompany"
                animatedPlaceholder={animatedPlaceholder}
                onChangeSuggestion={onChangeSuggestion}
                handleSuggestionsClearRequested={clearTypeahed}
                onFocus={this.onFocus}
                formatOptionLabel={renderMultiSuggestion}
                error={error}
                disabled={disabled}
                required={isRequired}
                t={t}
            />
        );
    }
}

const mapStateToProps = ({ typeahead }) => ({
    suggestions:
        typeahead.source === PositionInCompanyTypeahead.name
            ? typeahead.list
            : PositionInCompanyTypeahead.defaultProps.suggestions
});

export default connect(mapStateToProps, {
    fetchAllTypeaheadPositionInCompany,
    clearTypeahed
})(PositionInCompanyTypeahead);
